'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';

const $ = jQuery.noConflict();

$(function() {
	if (!$('.js-cf7-holder').length) {
		return;
	}

	cf7Helpers.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
});
